import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { GoogleTagManagerModule, GoogleTagManagerService } from 'angular-google-tag-manager';
import { filter, map, tap } from 'rxjs/operators';

import { environment } from 'environments/environment';

import { AuthService } from './shared/services/auth.service';
import { InactivityMonitorService } from './shared/services/inactivity-monitor.service';
import { StructuredDataService } from './shared/services/structured-data.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, GoogleTagManagerModule]
})
export class AppComponent implements OnInit, OnDestroy {
	title = 'Marketplace';

	constructor(
		private authService: AuthService,
		private inactivityMonitorService: InactivityMonitorService,
		private gtmService: GoogleTagManagerService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private titleService: Title,
		private structuredDataService: StructuredDataService,
	) {}

	ngOnInit(): void {
		this.structuredDataService.setWebsiteSchema({
			name: 'Wine Ark Marketplace',
			url: environment.basePortalUrl,
			searchUrl: `${environment.basePortalUrl}/listings?filterText=`,
			parent: {
				name: "Wine Ark | Australia's Leading Wine Storage Provider",
				url: environment.baseWineArkUrl,
			},
		});

		// Load google tag manager
		this.gtmService.addGtmToDom().catch(() => console.warn('Unable to load GTM'));

		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				/* tap((event: NavigationEnd) => {
        const gtmTag = {
          event: 'page',
          pageName: event.url
        };

        this.gtmService.pushTag(gtmTag).catch(() => console.warn("Unable to push GTM tag", gtmTag));
      }), */
				map<NavigationEnd, string>(() => {
					let child = this.activatedRoute.firstChild;
					while (child) {
						if (child.firstChild) child = child.firstChild;
						else if (child.snapshot.data?.title) return child.snapshot.data.title;
						else return null;
					}
				}),
				tap((title: string) => {
					this.titleService.setTitle((title ? title + ' - ' : '') + 'Wine Ark Marketplace');
				}),
			)
			.subscribe();

		this.authService.initAuth();

		if (environment.production) {
			this.inactivityMonitorService.start();
		}
	}

	ngOnDestroy(): void {
		this.authService.ngOnDestroy();
		this.inactivityMonitorService.stop();
	}
}
